import { HelpCircle } from 'lucide-react';
import { useHelp } from '../help/helpContext';

/** Top-bar help trigger — opens the help drawer for the current page. Present on every screen. */
export function HelpButton() {
  const { open } = useHelp();
  return (
    <button type="button" onClick={open} className="p-2 text-gray-500 hover:text-gray-700" aria-label="Open help">
      <HelpCircle className="h-5 w-5" />
    </button>
  );
}
